import FitnessCenterOutlined from '@mui/icons-material/FitnessCenterOutlined'
import SpeedOutlined from '@mui/icons-material/SpeedOutlined'
import {Divider} from '@mui/material'
import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import {useHasFeatureFlag} from '../../../../components/FeatureFlagOnly'
import {FeatureFlagWorkout} from '../../../../enums/plan'
import {useUserHelperGetCurrent} from '../../../../hooks/entity/useUser'
import {useSpotUrl} from '../../../../hooks/useSpotNavigate'
import {NavGroup} from './NavGroup'
import {NavLink} from './NavLink'

export const MenuGlobal = memo(() => {
  const {t} = useTranslation()
  const statsUrl = useSpotUrl('/profile/me/stats', true)
  const workoutUrl = useSpotUrl('/workouts', true)
  const {user} = useUserHelperGetCurrent()
  const hasFeatureFlag = useHasFeatureFlag(FeatureFlagWorkout)

  if (!user && !hasFeatureFlag) {
    return null
  }

  return <>
    <Divider/>
    <NavGroup>
      {user && <NavLink
        icon={<SpeedOutlined/>}
        to={statsUrl}
        label={t('common.menu.global.dashboard')}
      />}
      {hasFeatureFlag && <NavLink
        icon={<FitnessCenterOutlined/>}
        to={workoutUrl}
        label={t('common.menu.global.workout')}
      />}
    </NavGroup>
  </>
})
